import { API } from 'aws-amplify';

const getThemeApi = async (pk: string, sk: string) => {
	return API.get(
		process.env.REACT_APP_NAME || '',
		`/themes?pk=${pk}&sk=${sk}`,
		{}
	);
};

export { getThemeApi };
